const getNumericValue = value => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const hasNonZeroValue = value => Math.abs(getNumericValue(value)) > 0.000001;

const getDetailTotal = detail => {
  if (detail?.column_total !== undefined && detail?.column_total !== null) {
    return detail.column_total;
  }

  return (
    getNumericValue(detail?.item_total) + getNumericValue(detail?.fringe_total)
  );
};

const filterDetailSheets = (detailSheets, includeZeroValueLineItems) => {
  const sheets = Array.isArray(detailSheets) ? detailSheets : [];

  if (includeZeroValueLineItems) return sheets;

  return sheets.filter(detail => hasNonZeroValue(getDetailTotal(detail)));
};

const filterLineItems = (lineItems, includeZeroValueLineItems) => {
  const items = Array.isArray(lineItems) ? lineItems : [];

  if (includeZeroValueLineItems) return items;

  return items
    .map(lineItem => {
      const details = filterDetailSheets(
        lineItem?.swimlane_item_detail_sheets,
        includeZeroValueLineItems
      );
      const children = filterLineItems(
        lineItem?.children,
        includeZeroValueLineItems
      );

      if (
        !hasNonZeroValue(lineItem?.cost) &&
        !details.length &&
        !children.length
      ) {
        return null;
      }

      return {
        ...lineItem,
        swimlane_item_detail_sheets: details,
        children,
      };
    })
    .filter(Boolean);
};

export const filterBudgetForPrint = (
  budgetData,
  { includeZeroValueCategories = true, includeZeroValueLineItems = true } = {}
) => {
  if (!budgetData) return budgetData;

  const swimlanes = Array.isArray(budgetData?.budget_swimlane)
    ? budgetData.budget_swimlane
    : [];

  return {
    ...budgetData,
    budget_swimlane: swimlanes
      .filter(
        swimlane =>
          includeZeroValueCategories || hasNonZeroValue(swimlane?.cost)
      )
      .map(swimlane => ({
        ...swimlane,
        swimlane_detail_sheets: filterDetailSheets(
          swimlane?.swimlane_detail_sheets,
          includeZeroValueLineItems
        ),
        budget_swimlane_lineitem: filterLineItems(
          swimlane?.budget_swimlane_lineitem,
          includeZeroValueLineItems
        ),
      })),
  };
};
